import React, { useEffect, useState } from "react";
import { Pagination, Table } from "react-bootstrap";
import { Tooltip } from "react-tooltip";

const ITEMS_PER_PAGE = 5;

const submittalHeaders1 = [
  { label: "Section Number", key: "section_number" },
  { label: "Section Name", key: "section_name" },
  { label: "Submittal Type", key: "submittal_type" },
  { label: "Description", key: "description" },
  { label: "Quantity Format", key: "quantity_format" },
  { label: "Submission Format", key: "submission_format" },
  { label: "Task", key: "task" },
  { label: "Submission Deadline", key: "submission_deadline" },
  { label: "Dependencies", key: "dependencies" },
];

const submittalHeaders2 = [
  { label: "Division", key: "division" },
  { label: "Section Number", key: "section_number" },
  { label: "Spec Page", key: "spec_page" },
  { label: "Submittal Type", key: "submittal_type" },
  { label: "Section", key: "section" },
  { label: "Description", key: "description" },
  { label: "Quantity Format", key: "quantity_format" },
  { label: "Submission Format", key: "submission_format" },
  { label: "Task", key: "task" },
  { label: "Submission Deadline", key: "submission_deadline" },
  { label: "Dependencies", key: "dependencies" },
];

const submittalHeaders3 = [
  { label: "Drawing Number", key: "drawing_number" },
  { label: "Drawing Title", key: "drawing_title" },
  { label: "Submittal Type", key: "submittal_type" },
  { label: "Description", key: "description" },
  { label: "Quantity Format", key: "quantity_format" },
  { label: "Submission Format", key: "submission_format" },
  { label: "Task", key: "task" },
  { label: "Submission Deadline", key: "submission_deadline" },
  { label: "Dependencies", key: "dependencies" },
];


const determineHeaderSet = (items) => {

  if (!items || items.length === 0) return [];

  const firstItem = items;
  const hasKeys = (keys) => keys.every((key) => key in firstItem);
  console.log(firstItem)
  console.log(hasKeys)
  if (hasKeys(["division"])) {
    return submittalHeaders2;
  } else if (hasKeys(["section_number"])) {
    return submittalHeaders1;
  } else if (hasKeys(["drawing_number"])) {
    return submittalHeaders3;
  }

  return [];
};

const SubmittalsReport = ({ AISelectedApp }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [submittals, setsubmittals] = useState([])
  const [headers, setHeaders] = useState([]);
  const indexOfLastItem = currentPage * ITEMS_PER_PAGE;
  const indexOfFirstItem = indexOfLastItem - ITEMS_PER_PAGE;
  const currentItems = submittals.slice(indexOfFirstItem, indexOfLastItem);
  const [pageNumbers, setPageNumbers] = useState([]);
  const totalPages = Math.ceil(submittals.length / ITEMS_PER_PAGE);

  // const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const fastBackward = () => setCurrentPage(1);
  const fastForward = () => {
    const totalPages = Math.ceil(submittals.length / ITEMS_PER_PAGE);
    setCurrentPage(totalPages);
  };
  const generatePageNumbers = () => {
    const totalPages = Math.ceil(submittals.length / ITEMS_PER_PAGE);
    const range = [];

    // Ensure we always show 5 pages, centered around the current page
    const maxPageCount = 5;
    let startPage = Math.max(1, currentPage - Math.floor(maxPageCount / 2));
    let endPage = Math.min(totalPages, startPage + maxPageCount - 1);

    // Adjust the start page if there are less than 5 pages at the end
    if (endPage - startPage + 1 < maxPageCount) {
      startPage = Math.max(1, endPage - maxPageCount + 1);
    }

    // Add pages to the range array
    for (let i = startPage; i <= endPage; i++) {
      range.push(i);
    }

    setPageNumbers(range);
  };

  // const generatePageNumbers = () => {
  //   const range = [];
  //   const totalPages = Math.ceil(submittals.length / ITEMS_PER_PAGE);

  //   setPageNumbers([]);
  //   if (totalPages <= 5) {
  //     for (let i = 1; i <= totalPages; i++) {
  //       range.push(i);
  //     }
  //   } else {
  //     let start = Math.max(2, currentPage - 2);
  //     let end = Math.min(totalPages - 1, currentPage + 2);

  //     // Always show first page
  //     range.push(1);

  //     // Show left ellipsis if gap exists
  //     if (start > 2) {
  //       // range.push("...");
  //     }

  //     // Middle pages
  //     for (let i = start; i <= end; i++) {
  //       range.push(i);
  //     }

  //     // Show right ellipsis if gap exists
  //     if (end < totalPages - 1) {
  //       // range.push("...");
  //     }

  //     // Always show last page
  //     range.push(totalPages);
  //   }

  //   setPageNumbers(range);
  // };
  const paginate = (pageNumber) => {
    if (pageNumber === "...") return;
    setCurrentPage(pageNumber);
  };

  useEffect(() => {
    console.log("AISelectedApp", AISelectedApp)
    const agentData = AISelectedApp?.agentData || [];
    setsubmittals(agentData);
    setHeaders(determineHeaderSet(agentData[0]));
    generatePageNumbers();
  }, [AISelectedApp])

  useEffect(() => {
    generatePageNumbers();
  }, [currentPage, submittals]);

  return (
    <div className="container mt-2 ">
      <Tooltip
        id="ai-summary-tooltip"
        className="tooltip-custom align-items-center"
      />

      <h3
        className=" d-flex justify-content-between align-items-center w-100"
        data-tooltip-id="ai-summary-tooltip"
        data-tooltip-content={'AttestaAI Report'}
      >
        <div className="analysis-row">
          <div className="d-flex align-items-center">
            <div className="custom-icon-wrapper">
              <span
                className="custom-icon attesta-blue"
                dangerouslySetInnerHTML={{
                  __html:
                    AISelectedApp?.summaryPmtIcon ||
                    '<i class="fa-solid fa-brain custom-icon"></i>',
                }}
              ></span>
            </div>
            <span className="ms-2 attesta-blue">
              {AISelectedApp?.summaryPmtLabel || 'AttestaAI Summary'}
            </span>
          </div>
        </div>
      </h3>

      {/* <h4 className="mb-3">Report Results</h4> */}
      <div className="submittal-table-container">
        <div
          style={{
            minHeight: '250px',
            maxHeight: 'calc(-250px + 100vh)',
            overflow: 'auto',
          }}
        >
          <Table hover>
            <thead className="custom-header-border">
              {/* <tr>
              <th>Type</th>
              <th>Section</th>
              <th>Description</th>
              <th>Quantity Format</th>
              <th>Submission Format</th>
              <th>Task</th>
              <th>Deadline</th>
              <th>Dependencies</th>
            </tr> */}
              <tr>
                {headers.map((header, index) => (
                  <th key={index}>{header.label}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {currentItems.length > 0 ? (
                currentItems.map((item, index) => (
                  // <tr key={index} className="custom-row-border">
                  //   <td>{item.type}</td>
                  //   <td>{item.section}</td>
                  //   <td>{item.description}</td>
                  //   <td>{item.quantity_format}</td>
                  //   <td>{item.submission_format}</td>
                  //   <td>{item.task}</td>
                  //   <td>{item.submission_deadline}</td>
                  //   <td>{item.dependencies}</td>
                  // </tr>
                  <tr key={index} className="custom-row-border">
                    {headers.map((header, idx) => (
                      <td key={idx}>{item[header.key] ?? "-"}</td>
                    ))}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8" className="text-center text-muted py-3">
                    No Submittals report available
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>

        {totalPages > 1 && (
          <Pagination className="custom-pagination justify-content-end mt-1">
            <Pagination.First
              onClick={fastBackward}
              disabled={currentPage === 1}
            />
            <Pagination.Prev
              onClick={() => paginate(currentPage - 1)}
              disabled={currentPage === 1}
            />
            {pageNumbers.map((number) => (
              <Pagination.Item
                key={number}
                active={number === currentPage}
                onClick={() => paginate(number)}
              >
                {number}
              </Pagination.Item>
            ))}
            <Pagination.Next
              onClick={() => paginate(currentPage + 1)}
              disabled={currentPage === totalPages}
            />
            <Pagination.Last
              onClick={fastForward}
              disabled={currentPage === totalPages}
            />
          </Pagination>
        )}
      </div>
    </div>
  );
};

export default SubmittalsReport;
